import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const text = t("marquee");
  return (
    <div className="relative overflow-hidden py-10 border-y border-white/10 select-none" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((n) => (
          <span key={n} className="font-display font-bold uppercase text-6xl lg:text-8xl text-outline pr-4">
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};
